module.exports = "<div style=\"text-align: center; padding: 5rem 1.5rem;\">\r\n    <h1>Welcome to CV E-Sign Portal!</h1>\r\n</div>\r\n"